var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertlinkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9104220_link_permalink_chain_hyperlink_connect_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8001 4.4C18.9334 4.4 17.3334 5.06667 16.0001 6.4L13.0667 9.33333C12.5334 9.86667 12.5334 10.6667 13.0667 11.2C13.6001 11.7333 14.4001 11.7333 14.9334 11.2L17.8667 8.26667C19.4667 6.66667 22.1334 6.66667 23.7334 8.26667C24.5334 9.06667 24.9334 10.1333 24.9334 11.2C24.9334 12.2667 24.5334 13.3333 23.7334 14.1333L20.8001 17.0667C20.2667 17.6 20.2667 18.4 20.8001 18.9333C21.0667 19.2 21.4667 19.3333 21.7334 19.3333C22.0001 19.3333 22.4001 19.2 22.6667 18.9333L25.6001 16C26.9334 14.6667 27.6001 13.0667 27.6001 11.2C27.6001 9.33333 26.9334 7.73334 25.6001 6.4C24.2667 5.06667 22.6667 4.4 20.8001 4.4Z",
    fill: "#163E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2 15.0667C11.7334 14.5333 11.7334 13.7333 11.2 13.2C10.6667 12.6667 9.86669 12.6667 9.33336 13.2L6.40002 16C5.06669 17.3333 4.40002 18.9333 4.40002 20.8C4.40002 22.6667 5.06669 24.2667 6.40002 25.6C7.73336 26.9333 9.33336 27.6 11.2 27.6C13.0667 27.6 14.6667 26.9333 16 25.6L18.9334 22.6667C19.4667 22.1333 19.4667 21.3333 18.9334 20.8C18.4 20.2667 17.6 20.2667 17.0667 20.8L14.1334 23.7333C12.5334 25.3333 9.86669 25.3333 8.26669 23.7333C7.46669 22.9333 7.06669 21.8667 7.06669 20.8C7.06669 19.7333 7.46669 18.6667 8.26669 17.8667L11.2 15.0667Z",
    fill: "#163E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1334 19.8667C12.4001 20.1333 12.8001 20.2667 13.0667 20.2667C13.3334 20.2667 13.7334 20.1333 14.0001 19.8667L19.7334 14.1333C20.2667 13.6 20.2667 12.8 19.7334 12.2667C19.2001 11.7333 18.4001 11.7333 17.8667 12.2667L12.1334 18C11.6001 18.4 11.6001 19.3333 12.1334 19.8667Z",
    fill: "#163E6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertlinkicon);
export default __webpack_public_path__ + "static/media/insertlinkicon.ab00ca19d581e5cae667ad4d82ccc4af.svg";
export { ForwardRef as ReactComponent };